import Axios from './config';

class KinOfEmergencyApi {
    static query() {
        return Axios({
            method: 'GET',
            url: '/kin-of-emergency/'
        });
    }

    static getForCustomer(id) {
        return Axios({
            method: 'GET',
            url: `kin-of-emergency/customer/${id}`
        })
            .then(res => {
                return res.data;
            })
            .catch(err => err);
    }

    static update(id, data) {
        return Axios({
            method: 'PUT',
            url: `kin-of-emergency/${id}`,
            data
        })
            .then(res => {
                return res.data;
            })
            .catch(err => err);
    }
}

export default KinOfEmergencyApi;
